/**
 * Action Name: md_sync_images
 */

export function syncImgData() {
	let data = {
		action: 'md_sync_img',
		security: md_object.nonce
	};

	let processMessage = 'Bilder werden synchronisiert. Bitte das Fenster nicht schließen!';

	jQuery.ajax({
		data: data,
		beforeSend: () => {
			jQuery('#response').html(processMessage);
		},
		success: (response) => {
			jQuery('#response').html(response);
		},
		error: (err) => {
			jQuery('#response').html(err);
		}
	});
}
